import { TagTypes } from '@monorepo/base/src/components/tag/tag';

export enum StatusEnum {
	PAUSED = 'PAUSED',
	ACTIVE = 'ACTIVE',
	DRAFT = 'DRAFT',
	DELETED = 'DELETED',
}

export type StatusType = StatusEnum.PAUSED | StatusEnum.ACTIVE | StatusEnum.DRAFT | StatusEnum.DELETED;

export interface IStatus {
	status?: StatusType;
}

export const mapToIcon = (status?: StatusType) => {
	const _status = status?.toUpperCase();
	if (_status === StatusEnum.ACTIVE) {
		return { icon: 'play', color: '#12B76A', className: 'active' };
	}
	if (_status === StatusEnum.PAUSED) {
		return { icon: 'pause-square', color: '#667085', className: 'paused' };
	}
	if (_status === StatusEnum.DRAFT) {
		return { icon: 'package', color: '#667085', className: 'draft' };
	}
	if (_status === StatusEnum.DELETED) {
		return { icon: 'x-close', color: '#EA4337', className: 'deleted' };
	}

	return { icon: 'play', color: '#12B76A', className: 'active' };
};

export const mapToTagStatus = (status?: StatusType) => {
	const _status = status?.toUpperCase();
	if (_status === StatusEnum.ACTIVE) {
		return TagTypes.Success;
	}
	if (_status === StatusEnum.PAUSED) {
		return TagTypes.Paused;
	}
	if (_status === StatusEnum.DRAFT) {
		return TagTypes.Draft;
	}
	if (_status === StatusEnum.DELETED) {
		return TagTypes.Deleted;
	}
	return TagTypes.Info;
};
